import "./App.css";
import "../src/css/style.css";
import "../src/fonts/stylesheet.css";
import React, { useContext, useEffect } from "react";
import Dashboard from "./pages/Dashboard";
import Landlord from "./pages/Landlord";
import PotentialLandlord from "./pages/PotentialLandlord";
import Tenants from "./pages/Tenants";
import Offers from "./pages/Offers";
import { Route, Routes, Navigate } from "react-router-dom";
import AppLayout from "./components/Layout/AppLayout";
import AuthLayout from "./components/Layout/AuthLayout";
import Login from "./pages/Login";
import { Ucontext } from "./context/Ucontext";
import LandLordDetail from "./pages/LandLordDetail";
// import { SnackbarProvider } from 'material-ui-snackbar-provider'
import { Toaster } from "react-hot-toast";
import RentedProperties from "./pages/RentedProperties";
import UnRentedProperties from "./pages/UnRentedProperties";
import NonTenants from "./pages/NonTenants";
import UserScoreProfile from "./pages/UserScoreProfile";
import Waitlist from "./pages/Waitlist";
import TransactionsRental from "./pages/TrasactionsRental";
import TransactionsAssigned from "./pages/TransactionAssigned";
import AddAdmin from "./pages/AddAdmin";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TranslationList from "./pages/TranslationList";
import Reports from "./pages/Reports";
import ForensicAnalysis from "./pages/ForensicAnalysis";
import ExperianReport from "./pages/ExperianReport";
import CreditsReport from "./pages/CreditsReport";
import AnalysisReport from "./pages/AnalysisReport";
import LLMCostAnalysis from "./pages/LLMCostAnalysis";
import VoiceConversations from "./pages/VoiceConversations";
import LandlordMetrics from "./pages/LandlordMetrics";
import TenantMetrics from "./pages/TenantMetrics";
import InsuranceMetrics from "./pages/InsuranceMetrics";
import SkorProtectMetrics from "./pages/SkorProtectMetrics";
import Docs from "./pages/Docs";
import ScoreConfigManagement from "./pages/ScoreConfigManagement";

function App() {
  const { authState, loadUser } = useContext(Ucontext);
  const { isLoggedIn } = authState;

  useEffect(() => {
    console.log("current auth state", authState);
    loadUser();
    //authDispatch({type:"LOGOUT",payload:"logged out"});
  }, []);

  return (
    <>
      {/*      
        <Routes >
          <Route element={<DashboardLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/landlord" element={<Landlord />} />
            <Route path="/tenants" element={<Tenants />} />
            <Route path="/users" element={<Users />} />
            <Route path="/rentprop" element={<Rentedproperties />} />
            <Route path="/unrentprop" element={<Unrentedproperties />} />
            <Route path="/offers" element={<Offers />} />
          </Route>
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<Login />} />
          </Route>
        </Routes> */}

      {/* <SnackbarProvider SnackbarProps={{ autoHideDuration: 2000 }}> */}
      <Toaster />
      <ToastContainer />
      <Routes>
        {!isLoggedIn ? (
          <>
            <Route element={<AuthLayout />}>
              <Route path="/login" element={<Login />} />
            </Route>
          </>
        ) : (
          <></>
        )}
        {/* nested routing */}

        <Route element={<AppLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/landlord" element={<Landlord />} />
          <Route path="/landlord-metrics" element={<LandlordMetrics />} />
          <Route path="/tenant-metrics" element={<TenantMetrics />} />
          <Route path="/insurance-metrics" element={<InsuranceMetrics />} />
          <Route path="/skor-protect-metrics" element={<SkorProtectMetrics />} />
          <Route path="/tenants" element={<Tenants />} />
          <Route path="/not-tenants" element={<NonTenants />} />
          <Route path="/rentprop" element={<RentedProperties />} />
          <Route path="/unrentprop" element={<UnRentedProperties />} />
          <Route path="/scoreProfile" element={<UserScoreProfile />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/add/admin" element={<AddAdmin />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/potential/landlords" element={<PotentialLandlord />} />
          <Route
            path="/transactions/rentalInfo"
            element={<TransactionsRental />}
          />
          <Route
            path="/transactions/assigned"
            element={<TransactionsAssigned />}
          />

          <Route
            path="/landlorddetail/:landlordid"
            element={<LandLordDetail />}
          />
          <Route path="/tenantdetail/:tenantid" element={<LandLordDetail />} />
          <Route path="/translation" element={<TranslationList />} />
          <Route path="/forensic-analysis" element={<ForensicAnalysis />} />
          <Route path="/experian-report" element={<ExperianReport />} />
          <Route path="/llm-cost-analysis" element={<LLMCostAnalysis />} />
          <Route path="/voice-conversations" element={<VoiceConversations />} />
          <Route path="/credits-ledger" element={<CreditsReport />} />
          <Route path="/analysis-ledger" element={<AnalysisReport />} />
          <Route path="/admin/score-config" element={<ScoreConfigManagement />} />
        </Route>
          <Route path="/docs" element={<Docs />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {/* </SnackbarProvider> */}
    </>
  );
}

export default App;
